module.exports = __webpack_public_path__ + "static/media/tt7_eten_in_spanje.aeda9ab0.jpeg";